import React from 'react';
import { FormControlLabel as FormControlLabelMUI, ThemeOptions, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { fieldTypes } from '@/helpers/constants';
import useWarningField from '@/hooks/useWarningField';

const useStyles = makeStyles(({ cartTheme }: ThemeOptions) => ({
  warningBG: {
    backgroundColor: cartTheme.alertWarningBg,
    borderRadius: '5px',
    padding: '5px',
  },
  warningText: {
    color: cartTheme.alertWarning,
  },
}));

interface FormControlLabelProps {
  disabled?: boolean;
  className?: string;
  label: string | React.ReactNode;
  labelPlacement?: 'start' | 'end' | 'top' | 'bottom';
  control: React.ReactElement;
  fieldPath: string[];
}

const FormControlLabel: React.FC<FormControlLabelProps> = (props) => {
  const { disabled = false, className, label, labelPlacement = 'top', control, fieldPath } = props;

  const classes = useStyles();
  const warning = useWarningField(fieldPath, fieldTypes.SWITCH);

  return (
    <FormControlLabelMUI
      label={<Typography className={`${warning ? classes.warningText : ''}`}>{label}</Typography>}
      labelPlacement={labelPlacement}
      disabled={disabled}
      control={control}
      className={`${className} ${warning ? `${classes.warningBG} warning` : ''}`}
    />
  );
};

export default FormControlLabel;
